export default "__VITE_ASSET__Bn61Oj6P__"